import { render, staticRenderFns } from "./EditorLight.vue?vue&type=template&id=40e4e5d3"
import script from "./EditorLight.vue?vue&type=script&lang=js"
export * from "./EditorLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports